
import {FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip} from "@mui/material";
import Person from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import {ErrorMessage} from "formik";
import PostcodeIcon from "@mui/icons-material/LocalPostOfficeRounded";
import * as React from "react";
import {Fragment} from "react";
import {HelpOutline} from "@mui/icons-material";
import RequiredAsterisk from "../../components/RequiredAsterisk";

export function InstallAddress({ values, handleChange, handleBlur, errors, touched, data }) {

  return (

    <Fragment>

      <h5 className="text-secondary mb-3">Installation Address <Tooltip title="What address will the product be installed at?" arrow><HelpOutline /></Tooltip></h5>
      {data.shipping === '0' && <p style={{height:'35px'}}>&nbsp;</p>}
      <FormControl fullWidth className="mb-4">
        <TextField name="install_firstname"
                   label={<>Install Firstname <RequiredAsterisk /></>}
                   value={values.install_firstname}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   error={!!(touched?.install_firstname && errors.install_firstname)}
                   helperText={touched?.install_firstname && errors.install_firstname}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><Person/></InputAdornment>
                     )
                   }}
        />

      </FormControl>


      <FormControl fullWidth className="mb-4">
        <TextField name="install_lastname" label={<>Install Lastname <RequiredAsterisk /></>} variant="outlined"
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_lastname}
                   error={!!(touched?.install_lastname && errors.install_lastname)}
                   helperText={touched?.install_lastname && errors.install_lastname}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><Person/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_phone" label={<>Install Phone <RequiredAsterisk /></>}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_phone}
                   error={!!(touched?.install_phone && errors.install_phone)}
                   helperText={touched?.install_phone && errors.install_phone}
                   InputProps={{
                     startAdornment: (<InputAdornment position='start'><PhoneIcon/></InputAdornment>)
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_email" label={<>Install Email Address <RequiredAsterisk /></>}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_email}
                   error={!!(touched?.install_email && errors.install_email)}
                   helperText={touched?.install_email && errors.install_email}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><EmailIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_street" label={<>Install Street Number & Name <RequiredAsterisk /></>}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_street}
                   error={!!(touched?.install_street && errors.install_street)}
                   helperText={touched?.install_street && errors.install_street}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><HomeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_suburb_town" label={<>Install Suburb or Town <RequiredAsterisk /></>}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_suburb_town}
                   error={!!(touched?.install_suburb_town && errors.install_suburb_town)}
                   helperText={touched?.install_suburb_town && errors.install_suburb_town}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><HomeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <InputLabel id="install-state-label">State <RequiredAsterisk /></InputLabel>
        <Select name="install_state"
                labelId="install-state-label"
                value={values.install_state}
                id="install-state"
                label="State *"
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(touched?.install_state && errors.install_state)}
        >
          <MenuItem selected value=""><em>None</em></MenuItem>
          <MenuItem value="ACT">Australian Capital Territory</MenuItem>
          <MenuItem value="NSW">New South Wales</MenuItem>
          <MenuItem value="NT">Northern Territory</MenuItem>
          <MenuItem value="QLD">Queensland</MenuItem>
          <MenuItem value="SA">South Australia</MenuItem>
          <MenuItem value="TAS">Tasmania</MenuItem>
          <MenuItem value="VIC">Victoria</MenuItem>
          <MenuItem value="WA">Western Australia</MenuItem>
        </Select>
        <ErrorMessage style={{letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px'}}
                      component="div" name="install_state" className="help-block errors text-danger"/>
      </FormControl>

      <FormControl fullWidth className="mb-5">
        <TextField name="install_postcode" label={<>Install Postcode <RequiredAsterisk /></>}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   value={values.install_postcode}
                   error={!!(touched?.install_postcode && errors.install_postcode)}
                   helperText={touched?.install_postcode && errors.install_postcode}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><PostcodeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

    </Fragment>
  );

}